import {IOrganisation} from 'app/blocks/model/organisation.model';
import {BaseEntity, IBaseEntity} from 'app/blocks/model/base-entity.model';

export interface IPreInvoiceBatch extends IBaseEntity {
    id?: number;
    batchId?: string;
    date?: Date;
    customer?: IOrganisation;
    customerId?: number;
    clientRef?: string;
    poRef?: string;
    totalNet?: number;
    extrasTotal?: number;
    fuelTotal?: number;
    taxTotal?: number;
    finalTotal?: number;
    orderIds?: number[];
    orders?: any[];
    vatRate?: any;
    vatType?: any;
    autoEmail?: boolean;
    batchRef?: string;
    createdBy?: string;
}

export class PreInvoiceBatch extends BaseEntity implements IPreInvoiceBatch {
    public id?: number;
    public batchId?: string;
    public date?: Date;
    public customer?: IOrganisation;
    public clientRef?: string;
    public poRef?: string;
    public totalNet?: number;
    public extrasTotal?: number;
    public fuelTotal?: number;
    public taxTotal?: number;
    public finalTotal?: number;
    public orderIds?: number[];
    public orders?: any[];
    public vatRate?: any;
    public vatType?: any;
    public autoEmail?: boolean;

    constructor(preInvoiceBatch?: any) {
        super();
        if (preInvoiceBatch) {
            this.id = preInvoiceBatch.id;
            this.batchId = preInvoiceBatch.batchId;
            this.date = preInvoiceBatch.date;
            this.customer = preInvoiceBatch.customer;
            this.clientRef = preInvoiceBatch.clientRef;
            this.poRef = preInvoiceBatch.poRef;
            this.totalNet = preInvoiceBatch.totalNet;
            this.extrasTotal = preInvoiceBatch.extrasTotal;
            this.taxTotal = preInvoiceBatch.taxTotal;
            this.finalTotal = preInvoiceBatch.finalTotal;
            this.orderIds = preInvoiceBatch.orderIds || [];
            this.orders = preInvoiceBatch.orders || [];
            this.vatType = preInvoiceBatch.vatType;
            this.vatRate = preInvoiceBatch.vatRate;
            this.autoEmail = preInvoiceBatch.autoEmail;
        } else {
            this.orderIds = [];
            this.orders = [];
        }
    }

    get discriminator(): any {
        return this.batchId;
    }

    clone(): PreInvoiceBatch {
        return new PreInvoiceBatch(this);
    }
}
